<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz21-1"><a id="page_9"></a><a href="#/contents#RR_19" id="CC_19"> Howard’s Bachelor Pad Punch</a></p>
<p class="tx6" id="pz21-2"><i> Bubbly, boys. </i></p>
<p class="tx5" id="pACX"><b> 1 packet cherry Kool-Aid </b></p>
<p class="tx5" id="pA9cC"><b> 1 packet strawberry Kool-Aid </b></p>
<p class="tx5" id="pAr0V"><b> 2 cups sugar </b></p>
<p class="tx5" id="pAs5s"><b> 2 quarts cold water </b></p>
<p class="tx5" id="pAn3L"><b> 1 6-ounce can frozen orange juice </b></p>
<p class="tx5" id="AdjH"><b> 1 6-ounce can frozen lemonade </b></p>
<p class="tx5" id="AnTg"><b> 1 quart ginger ale </b></p>
<p class="tx1" id="pAurq"><span class="dcap">D</span>issolve Kool-Aid and sugar in water. Add juices. Pour into punch bowl and slowly add ginger ale.</p>
<p class="tx" id="pAJk"> Makes 1 gallon.</p>
<p class="txrr" id="pAkmX"> <i>Janine Johnson—Orlando, Florida</i></p>
<div class="box" id="AGR">
<p class="tx1a" id="pAix"><i>Great shakes at Opie’s new soda fountain job:</i></p>
<table id="pAZM">
<tbody id="AZM" style="vertical-align: top;">
<tr id="tr-AZM-0">
<td id="td-AZM-0-0">HOWARD</td>
<td id="td-AZM-0-1">(to Andy): He’s a pro at that counter, all right. I especially like the way he makes the malteds. You know, he gets the ice cream mixed in thoroughly.</td>
</tr>
<tr id="tr-AZM-1">
<td colspan="2" id="td-AZM-1-0"><i>Later</i>:</td>
</tr>
<tr id="tr-AZM-2">
<td id="td-AZM-2-0"><p class="txtb">HOWARD:</p></td>
<td id="td-AZM-2-1">Hey, Ope. That malted you made for me at lunch—par excellence.</td>
</tr>
</tbody>
</table>
</div>
<div class="image" id="pAA7N">
<p class="ser"><img alt="images/img-21-1.jpg" id="AA7N" src="images/img-21-1.jpg"/></p>
<p class="txcc" id="pABIj"> <i>Without his bow tie, Howard could be Mayberry’s swingingest bachelor.</i></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter19.vue?9ee6389e